import React from 'react';
import ClassAssembly11C from 'views/ClassAssembly11C';

const ClassAssembly11CPage = () => {
    return <ClassAssembly11C />;
  };
  
  export default ClassAssembly11CPage;

  